<!-- components/FetchTracker.vue -->
<template>
  <div class="container">
    <slot name="headline">
      <h2 class="heading">Pending Requests</h2>
    </slot>
    <div
        v-for="req in requests"
        :key="req.id"
        class="request"
        :class="[ `state-${req.state}` ]"
    >
      <div class="path">
        <slot :item="req">
          {{ req.type !== 'fetch' ? req.type.toUpperCase().slice(0,3) : req.method }} {{ req.url.pathname }}
        </slot>
      </div>
      <div class="progress-bar">
        <div class="progress" :style="{ width: req.progress + '%' }"></div>
      </div>
      <div class="state">{{ req.state.slice(0,1).toUpperCase() }}{{ req.state.slice(1) }}</div>
      <div class="error" v-if="req.state == 'error'">{{ req.error }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRequestTrackerStore } from '../stores/requestTracker'
import { storeToRefs } from 'pinia'

const store = useRequestTrackerStore()
const { requests } = storeToRefs(store)
</script>

<style scoped lang="scss">
.container {
  padding: 1rem;
  width: 100%;
}

.heading {
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.request {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0.75rem;
  margin-bottom: 1rem;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);

  &.state-error {
    color: #e74c3c;
  }
  &.state-success {
    color: #2ecc71;
  }
  &.state-pending {
    color: #808080;
  }

  .path {
    font-family: monospace;
    font-size: 0.875rem;
    word-wrap: anywhere;
  }

  .progress-bar {
    background-color: #eee;
    border-radius: 4px;
    height: 8px;
    margin-top: 0.5rem;
    overflow: hidden;
  }

  .progress {
    background-color: #3498db;
    height: 100%;
    transition: width 0.3s ease;
  }

  .state {
    margin-top: 0.5rem;
    font-size: 0.875rem;
  }
}
</style>
